import { useEffect } from 'react';
export var keyDownHandler = function (firstElement, lastElement, e) {
    if (e.key !== 'Tab')
        return;
    if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
    }
    if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
    }
};
var selectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea',
    'input',
    'select',
];
export var useTrapFocus = function (ref) {
    useEffect(function () {
        var _a, _b;
        var focusableElements = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selectors.join(', '));
        var firstElement = focusableElements[0];
        var lastElement = focusableElements[focusableElements.length - 1];
        var boundKeydownHandler = keyDownHandler.bind(null, firstElement, lastElement);
        (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.addEventListener('keydown', boundKeydownHandler);
        return function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', boundKeydownHandler); };
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
};
